import { createPathComponent } from "@react-leaflet/core"
import type { LeafletContextInterface, PathProps } from "@react-leaflet/core"
import type { LatLng } from "leaflet"
import type { PropsWithChildren } from "react"
import type { PolylineOverwriteLayer } from "../../../utils"
import { polylineOverwrite } from "../../../utils"

export interface IPolylineShapeOverwriteProps extends PathProps {
  latlngs: LatLng[]
}

export const PolylineShapeOverwrite = createPathComponent<
  PolylineOverwriteLayer,
  PropsWithChildren<IPolylineShapeOverwriteProps>
>(
  ({ latlngs, ...options }, ctx: LeafletContextInterface) => {
    const instance: PolylineOverwriteLayer = new polylineOverwrite(latlngs, options)
    return { instance, context: { ...ctx, overlayContainer: instance } }
  },
  (layer: PolylineOverwriteLayer, props: IPolylineShapeOverwriteProps, prevProps: IPolylineShapeOverwriteProps) => {
    if (props.latlngs !== prevProps.latlngs) {
      layer.setLatLngs(props.latlngs)
    }
  }
)
